import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "line-chart",
  "use": "line-chart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"line-chart\"><path fill-rule=\"evenodd\" d=\"m3.5 18.48 6-6.01 4 4L22 6.91 20.59 5.5l-7.09 7.97-4-4L2 16.98z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol